export const lessonContentError = {
    "name": "Contenido no disponible",
    "content": {
        "nodeType": "document",
        "content": [
            {
                "nodeType": "paragraph",
                "content": [
                    {
                        "value": "El contenido de esta lección no está disponible en este momento.",
                        "nodeType": "text"
                    },
                ]
            },
            {
                "nodeType": "paragraph",
                "content": [
                    {
                        "value": "Por favor, intenta más tarde o contacta a ",
                        "nodeType": "text"
                    },
                    {
                        "value": "soporte",
                        "nodeType": "text",
                        "marks": [
                            {
                                "type": "bold"
                            }
                        ]
                    },
                    {
                        "value": ".",
                        "nodeType": "text"
                    }
                ]
            }
        ]
    },
    "hasErrors": true
}